<template>
  <v-card class="mt-auto">
    <v-card-title>
      <v-btn text color="deep-orange darken-1" @click="$router.back()">
        <v-icon class="mx-2">arrow_back</v-icon>
        back
      </v-btn>
      <v-spacer />
      Approved Applications
      <v-spacer />
      <v-btn class="primary text-capitalize" @click="syncAll()">
        Sync All
        <v-icon class="mx-2">sync</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
        id="scollStyle"
        ref="applications_list"
        :headers="headers"
        :items="applications"
        :sort-desc="[false, true]"
        multi-sort
        class="elevation-0"
      >
        <!--eslint-disable-next-line -->
        <template v-slot:item.remarks="{ item }">
          <span class="font-weight-bold">{{ item["remarks"] }}</span>
        </template>
        <!--eslint-disable-next-line -->
        <template v-slot:item.student="{ item }">
          {{
            `${item.user.profile.searchName} (${item.user.profile.studentNo})`
          }}
        </template>
        <!--eslint-disable-next-line -->
          <template v-slot:item.status="{ item }">
          <span>
            <v-icon
              size="14"
              :color="statusColor[item.status.toLowerCase().trim()]"
            >
              mdi-radiobox-marked
            </v-icon>
            {{ item.status }}
          </span>
        </template>
        <!--eslint-disable-next-line -->
        <template v-slot:item.action="{ item }">
          <v-btn small class="primary text-capitalize" @click="sync(item)">
            Sync
            <v-icon class="ml-1">sync</v-icon>
          </v-btn>
        </template>
        <!--END board actions-->
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { helper } from "../../../dashboard/utils";
export default {
  name: "ApplicationsComponent",
  data: function () {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Administrator/getApplications");
    });
  },
  computed: {
    applications: function () {
      return this.$store.getters["Administrator/administratorGetters"](
        "applications",
      );
    },
    statusColor: function () {
      return helper.status();
    },
    headers() {
      return [
        {
          text: "#S/N",
          sortable: true,
          value: "applicationID",
        },
        { text: "Applied On", sortable: true, value: "applicationDate" },
        {
          text: "Student",
          sortable: true,
          value: "student",
        },
        {
          text: "Programme",
          sortable: true,
          value: "programme",
        },
        {
          text: "Stage",
          sortable: true,
          value: "stage",
        },
        {
          text: "Status",
          sortable: true,
          value: "status",
        },
        {
          text: "Actions",
          sortable: true,
          value: "action",
        },
      ];
    },
  },
  methods: {
    syncAll() {
      this.$store.dispatch("Administrator/syncAllApplications");
    },
    sync(application) {
      const data = { applicationNo: application.applicationID };
      this.$store.dispatch("Administrator/syncApplication", data);
    },
  },
};
</script>
